import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {ListGroup, ListGroupItem, OverlayTrigger, Panel, Popover} from 'react-bootstrap';
import {CONSTANTS} from 'js/common';

const {PostTags} = CONSTANTS;

const ContentFiltersDropdown = props => {
    const {
        changeIncludeContentFilter,
        changeExcludeContentFilter,
        excludeContentFilters,
        includeContentFilters
    } = props;
    const {tree} = PostTags;

    const parentListItems = R.map(key => {
        const tag = tree[key];
        const parent = tag.name;
        const children = R.values(tag.children);

        const parentIsSelected = R.contains(parent, includeContentFilters);
        const tagHasChildren = R.length(children) > 0;

        const childrenListItems = R.map(child => {
            const childIsExcluded = R.contains(child, excludeContentFilters);

            const handleChildItemClick = e => {
                if (parentIsSelected) {
                    changeExcludeContentFilter(child);
                }
            };

            return (
                <ListGroupItem key={child} className="child-tag-list-item">
                    <span
                        className={`child-tag tag-checkbox ${
                            parentIsSelected && !childIsExcluded ? 'selected' : 'unselected'
                        }`}
                        onClick={e => handleChildItemClick(e)}
                        role='radio'
                    >
                        {child}
                    </span>
                </ListGroupItem>
            );
        }, children);

        const handleParentItemClick = e => {
            e.preventDefault();
            return changeIncludeContentFilter(parent);
        };

        const parentHeader = (
            <div>
                <span className="parent-tag-name">
                    {parent}
                    &nbsp;
                </span>
                <span
                    className={`parent-tag-icon tag-checkbox ${
                        parentIsSelected ? 'selected' : 'unselected'
                    }`}
                    onClick={e => {
                        handleParentItemClick(e);
                    }}
                    role='radio'
                />
            </div>
        );

        const parentListItem = (
            <ListGroupItem key={parent} className="parent-tag-list-item">
                {tagHasChildren && parentIsSelected ? (
                    <Panel className="parent-tag-panel" header={parentHeader} collapsible>
                        <ListGroup fill>{childrenListItems}</ListGroup>
                    </Panel>
                ) : (
                    parentHeader
                )}
            </ListGroupItem>
        );

        return parentListItem;
    }, R.keys(tree));

    const contentFiltersPopover = (
        <Popover id="content-filters-popover" className="content-filters-popover dropdown-menu">
            <ListGroup fill role='radiogroup'>{parentListItems}</ListGroup>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={contentFiltersPopover}
            rootClose
        >
            <button className="content-filters-button">
                Content Filters
            </button>
        </OverlayTrigger>
    );
};

ContentFiltersDropdown.propTypes = {
    changeIncludeContentFilter: PropTypes.func.isRequired,
    changeExcludeContentFilter: PropTypes.func.isRequired,
    excludeContentFilters: PropTypes.array.isRequired,
    includeContentFilters: PropTypes.array.isRequired
};

export default ContentFiltersDropdown;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/content_filters_dropdown.js